import {TranslationFunction} from 'translations';
import * as Yup from 'yup';

export const checkoutValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    address_id: Yup.number().required(t('addressNotSelected')),
    customer: Yup.object({
      name: Yup.string().required(t('nameRequired')),
      email: Yup.string().nullable(true).email(t('invalidEmail')).required(t('FIELD_IS_REQUIRED')),
    }),
  });

export const userValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    name: Yup.string().required(t('nameRequired')),
    phone: Yup.string().required(t('PHONE_NUMBER_NOT_VALID')),
  });

export const promoValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    promoCode: Yup.string().required(t('FIELD_IS_REQUIRED')).max(50, t('THIS_FIELD_IS_TOO_LONG')),
  });

export const addressValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    apartment: Yup.string()
      .max(10, t('THIS_FIELD_IS_TOO_LONG'))
      .when(['is_private_building'], (isPrivate, schema) => {
        return !isPrivate ? schema : schema.required(t('FIELD_IS_REQUIRED'));
      }),
    entrance: Yup.number()
      .nullable()
      .integer(t('validNumberWithoutDecimals'))
      .max(999, t('tooHighNumber'))
      .when('apartment', {
        is: (apartment: string) => !!apartment, // Validate only if apartment is not empty
        then: (schema) => schema.required(t('FIELD_IS_REQUIRED')),
        otherwise: (schema) => schema.notRequired(),
      }),
    floor: Yup.number()
      .nullable()
      .integer(t('validNumberWithoutDecimals'))
      .max(50, t('tooHighNumber'))
      .when('apartment', {
        is: (apartment: string) => !!apartment, // Validate only if apartment is not empty
        then: (schema) => schema.required(t('FIELD_IS_REQUIRED')),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

export const loginValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    email: Yup.string().required(t('FIELD_IS_REQUIRED')).email(t('invalidEmail')).nullable(),
    name: Yup.string().max(50).min(2).nullable().required(t('FIELD_IS_REQUIRED')),
  });

export const profileValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    name: Yup.string().required(t('nameRequired')),
    email: Yup.string().required().email(t('invalidEmail')),
    phonenumber: Yup.string().required(t('PHONE_NUMBER_NOT_VALID')),
  });

export const phoneValidationSchema = (t: TranslationFunction) =>
  Yup.object({
    phone: Yup.string()
      .matches(/^\+?[0-9]+$/, t('PHONE_NUMBER_NOT_VALID')) // Allow optional '+' at the start
      .min(8, t('PHONE_NUMBER_NOT_VALID'))
      .nullable(true)
      .required(t('FIELD_IS_REQUIRED')),
  });
